<template>
  <div class="container">
    <div class="page">
      <div class="header">
        <div class="left">
          订单已生产完成，请尽快支付尾款！订单号：{{ detail.order_no }}
        </div>
        <div class="right">
          应付尾款 <span class="money">￥{{ detail.tail }}</span>
        </div>
      </div>
      <div class="pay-methods">
        <div class="pay-title">支付方式:</div>
        <div class="methods-box">
          <div
            :class="['method-items', { active: pay_type === 'wechat' }]"
            @click="onPayMethodChange('wechat')"
          >
            微信支付
            <img
              v-if="pay_type === 'wechat'"
              src="../../assets/images/icon-selected-paymethods.png"
              alt=""
              class="selected-icon"
            />
          </div>
          <div
            :class="['method-items', { active: pay_type === 'alipay' }]"
            @click="onPayMethodChange('alipay')"
          >
            支付宝支付
            <img
              v-if="pay_type === 'alipay'"
              src="../../assets/images/icon-selected-paymethods.png"
              alt=""
              class="selected-icon"
            />
          </div>
          <div
            :class="['method-items', { active: pay_type === 'balance' }]"
            @click="onPayMethodChange('balance')"
          >
            余额支付(余额:¥{{ userInfo.available_balance | price_format }})
            <img
              v-if="pay_type === 'balance'"
              src="../../assets/images/icon-selected-paymethods.png"
              alt=""
              class="selected-icon"
            />
          </div>
        </div>
      </div>
      <div class="content">
        <template v-if="pay_type != 'balance'">
          <div class="img-wrap">
            <img :src="pay_type | pay_methods_icon" alt="" class="icon" />
            <span>{{ pay_type | pay_methods_name }}支付</span>
          </div>
          <div class="tip">
            距离二维码过期还剩
            <span class="second">{{ second }}</span>
            秒，过期后请刷新页面重新获取二维码
          </div>
          <div class="code-wrap">
            <div class="left">
              <div class="qrcode">
                <canvas
                  v-if="pay_type === 'wechat'"
                  width="270"
                  height="270"
                  ref="c"
                  id="qrccode-canvas"
                  style="width: 100%; height: 100%"
                ></canvas>
                <template v-else-if="pay_type === 'alipay'">
                  <iframe
                    v-if="alipayFormContent"
                    ref="alipayIframe"
                    width="270"
                    height="270"
                    frameborder="0"
                    style="width: 100%; height: 100%"
                    :srcdoc="alipayFormContent"
                  ></iframe>
                </template>
                <p class="hint">
                  请使用{{ pay_type | pay_methods_name }}扫一扫<br />
                  扫描二维码支付
                </p>
              </div>
            </div>
            <div class="right">
              <img :src="pay_type | pay_methods_help" alt="" class="help" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="balance-pay">
            <div class="balance-pay-btn" @click="onOrderPay">确认支付</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
let QRCode = require("qrcode");
import { Profile, OrderDetail, PayTailOrder, CheckPayStatus } from "@/api/index.js";
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "PayTail",
  components: {},
  data() {
    return {
      uuid: "",
      pay_type: "",
      detail: {},
      second: 300,
      interval_id1: null,
      interval_id2: null,
      log_id: 0,
      alipayFormContent: "",
    };
  },
  computed: {
    ...mapState(["setting", "userInfo"]),
  },
  beforeRouteLeave(to, from, next) {
    this.stopPayPolling();
    next();
  },
  beforeDestroy() {
    this.stopPayPolling();
  },
  methods: {
    stopPayPolling() {
      if (this.interval_id1) {
        clearInterval(this.interval_id1);
        this.interval_id1 = null;
      }
      if (this.interval_id2) {
        clearInterval(this.interval_id2);
        this.interval_id2 = null;
      }
    },
    onPayMethodChange(type) {
      this.stopPayPolling();
      this.pay_type = type;
      this.alipayFormContent = "";
      this.second = 300;
      if (["wechat", "alipay"].includes(type)) {
        this.onOrderPay();
      }
    },
    generate(url) {
      QRCode.toCanvas(this.$refs.c, url, { width: 270 }, (error) => {
        if (error) {
          console.log(error);
        }
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    onOrderPay() {
      const { uuid, pay_type } = this;
      const param = {};
      param.uuid = uuid;
      param.pay_type = pay_type;
      if (pay_type === "balance") {
        if (!this.detail.tail) {
          this.$layer.msg("订单信息加载中，请稍后重试");
          return;
        }
        if (Number(this.userInfo.available_balance) < Number(this.detail.tail)) {
          this.$layer.msg("余额不足，请选择其他支付方式");
          return;
        }
        this.$Spin.show();
      }
      PayTailOrder(param)
        .then((response) => {
          if (pay_type === "wechat") {
            this.generate(response.data.url);
            this.stopPayPolling();
            this.interval_id1 = setInterval(() => {
              this.second--;
              if (this.second === 0) {
                this.stopPayPolling();
                this.second = 300;
                location.reload();
              }
            }, 1000);
            this.interval_id2 = setInterval(() => {
              CheckPayStatus({ pay_id: response.data.pay_id }).then((res) => {
                if (res.data.status === 1) {
                  this.stopPayPolling();
                  this.$router.replace({
                    name: "PayResult",
                    query: { uuid: this.uuid },
                  });
                }
              });
            }, 3000);
          } else if (pay_type === "alipay") {
            if (response.data.type === "form") {
              this.alipayFormContent = response.data.content;
              setTimeout(() => {
                const iframe = this.$refs.alipayIframe;
                if (iframe && iframe.contentDocument) {
                  const form = iframe.contentDocument.querySelector("form");
                  if (form) {
                    form.submit();
                  }
                }
              }, 500);
            }
            this.stopPayPolling();
            this.interval_id1 = setInterval(() => {
              this.second--;
              if (this.second === 0) {
                this.stopPayPolling();
                this.second = 300;
                location.reload();
              }
            }, 1000);
            this.interval_id2 = setInterval(() => {
              CheckPayStatus({ pay_id: response.data.pay_id }).then((res) => {
                if (res.data.status === 1) {
                  this.stopPayPolling();
                  this.$router.replace({
                    name: "PayResult",
                    query: { uuid: this.uuid },
                  });
                }
              });
            }, 3000);
          } else if (pay_type === "balance") {
            this.$layer.msg("支付成功");
            this.$router.replace({
              name: "PayResult",
              query: { uuid: this.uuid },
            });
          }
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        })
        .finally(() => {
          if (pay_type === "balance") {
            this.$Spin.hide();
          }
        });
    },
  },
  mounted() {
    this.uuid = this.$route.query.uuid;
    this.pay_type = this.$route.query.pay_type || "wechat";
    if (this.$route.query.uuid) {
      OrderDetail({
        uuid: this.$route.query.uuid,
      }).then((response) => {
        this.detail = response.data;
      });
    }
    if (["wechat", "alipay"].includes(this.pay_type)) {
      this.onOrderPay();
    }
    axios.all([this.getProfile()]).then(axios.spread(() => {}));
  },
};
</script>

<style scoped lang="scss">
.container {
  background: #f6f7fa;
  padding: 30px 200px 100px 200px;
  .page {
    width: 1500px;
    margin: 0 auto;
    padding: 0 70px;
    background: white;
    border-radius: 10px 10px 10px 10px;
    .header {
      height: 92px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #dbdbdb;
      color: #333;
      .right {
        .money {
          font-size: 24px;
          color: #fa3d5a;
        }
      }
    }

    .pay-methods {
      display: flex;
      align-items: center;
      column-gap: 30px;
      margin-top: 30px;

      .pay-title {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
      }

      .methods-box {
        display: flex;
        align-items: center;
        column-gap: 20px;

        .method-items {
          color: #333333;
          font-size: 16px;
          padding: 17px 35px;
          border: 1px solid #cccccc;
          position: relative;
          cursor: pointer;

          &.active {
            border: 1px solid #3478ff;
          }

          .selected-icon {
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 24px;
          }
        }
      }
    }

    .content {
      .img-wrap {
        display: flex;
        align-items: center;
        font-size: 26px;
        margin: 25px 0;
        .icon {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
      }
      .tip {
        color: #737373;
        font-size: 14px;
        .second {
          color: #fa3d5a;
        }
      }

      .code-wrap {
        padding: 66px 0 200px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .left {
          .qrcode {
            width: 270px;
            height: 270px;
          }
          .hint {
            background: #fa3d5a;
            padding: 5px 10px;
            color: white;
            text-align: center;
          }
        }

        .right {
          .help {
            margin-left: 100px;
            width: 250px;
            height: 320px;
          }
        }
      }
      .upload-result {
        display: flex;
        justify-content: center;
        align-items:center;
        flex-wrap: wrap;
        column-gap: 75px;
        margin-top: 49px;
        .upload-btn {
          width: 301px;
          height: 301px;
          background: #f5f8f7;
          border: 1px dashed #cccccc;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .btn-icon {
            width: 82px;
            height: 63px;
          }
          .btn-text {
            margin-top: 28px;
            margin-bottom: 19px;
            font-weight: bold;
            color: #5b5f66;
            font-size: 16px;
          }
          .btn-desc {
            color: #999999;
            font-size: 13px;
          }
        }
        .upload-res {
          position: relative;
          width: 300px;
          height: 300px;
          overflow: visible;
          .res-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .remove-btn {
            position: absolute;
            top: -10px;
            right: -10px;
            width: 28px;
            height: 28px;
            z-index: 10;
          }
        }
        .upload-tips {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .tips-title {
            color: #999999;
            font-weight: bold;
            font-size: 16px;
          }
          .tips-content {
            margin-top: 25px;
            color: #808080;
            font-size: 13px;
            line-height: 28px;
            .line{
              width:100%;
              border-bottom:1px dashed #cccccc;
              margin:26px 0;
            }
            .pay-title{
              color:#333333;
              font-size:16px;
              margin-bottom:19px;
            }
            .pay-item{
              display: flex;
              align-items:center;
              font-size:13px;
              .label{
                color:#666666;
              }
              .value{
                color:#1a1a1a;
                span{
                  border-radius:11px;
                  border:1px solid #fa3d5a;
                  cursor:pointer;
                  color:#fa3d5a;
                  padding:3px 10px;
                  margin-left:10px;
                }
              }
            }
          }
        }
        .btn-box {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 60px;
          margin-bottom: 73px;
          .btn {
            border-radius: 30px;
            width: 260px;
            height: 60px;
            background: #fa3d5a;
            color: #ffffff;
            line-height: 60px;
            cursor: pointer;
            text-align: center;
            font-size: 14px;
          }
        }
        .back-btn {
          width: 100%;
          margin-bottom: 104px;
          color: #575859;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .balance-pay {
        width: 100%;
        padding-bottom: 30px;
        .balance-pay-btn {
          width: 200px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #ffffff;
          background: #fa3d5a;
          border-radius: 30px;
          margin-top: 20px;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep .ivu-upload-drag {
  overflow: visible;
}

@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .container {
    padding: 30px 100px 100px 100px;

    .page {
      width: 100%;
      padding: 0 50px;

      .pay-methods {
        column-gap: 20px;
        margin-top: 25px;

        .methods-box {
          column-gap: 15px;

          .method-items {
            padding: 15px 25px;
            font-size: 15px;
          }
        }
      }

      .balance-pay {
        .balance-pay-btn {
          width: 180px;
          height: 45px;
          line-height: 45px;
          font-size: 13px;
        }
      }
    }
  }
}

@media screen and (max-width: 1279px) {
  .container {
    padding: 20px 20px 50px 20px;

    .page {
      width: 100%;
      padding: 0 20px;
      border-radius: 8px;

      .pay-methods {
        column-gap: 15px;
        margin-top: 20px;
        flex-wrap: wrap;

        .pay-title {
          font-size: 15px;
        }

        .methods-box {
          column-gap: 10px;
          flex-wrap: wrap;

          .method-items {
            padding: 12px 20px;
            font-size: 14px;
          }
        }
      }

      .balance-pay {
        .balance-pay-btn {
          width: 150px;
          height: 40px;
          line-height: 40px;
          font-size: 12px;
          margin-top: 15px;
        }
      }
    }
  }
}
</style>
